import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { toast } from 'react-hot-toast';
import TabAjustes from '../rentabilidad/TabAjustes';

// % de impuestos (28-oct-2026): estaba en el desglose del Balance; el Balance pasó a ser el Resumen
function PorcentajeImpuestos() {
    const [pct, setPct] = useState(null);
    const [texto, setTexto] = useState('');
    const [guardando, setGuardando] = useState(false);
    useEffect(() => { api.get('/configuracion').then(r => { setPct(r.data.porcentajeImpuestos); setTexto(String(r.data.porcentajeImpuestos ?? 30)); }).catch(() => setPct(30)); }, []);
    const guardar = async () => {
        const v = Number(String(texto).replace(',', '.'));
        if (!Number.isFinite(v) || v < 0 || v > 100) { toast.error('Poné un porcentaje de 0 a 100'); return; }
        setGuardando(true);
        try { const r = await api.put('/configuracion', { porcentajeImpuestos: Math.round(v) }); setPct(r.data.porcentajeImpuestos); toast.success(`Impuestos: ${Math.round(v)}%`); }
        catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); }
        finally { setGuardando(false); }
    };
    return (
        <div className="p-3.5 rounded-2xl bg-card border border-black/[0.07] dark:border-white/[0.07] space-y-2">
            <p className="text-label font-black uppercase tracking-widest text-muted">Impuestos</p>
            <p className="text-caption text-secondary">Se descuenta de lo cobrado con factura o transferencia (lo de efectivo sin factura no paga). También lo usa la liquidación de los técnicos.</p>
            <div className="flex items-center gap-2">
                <span className="relative w-28">
                    <input type="text" inputMode="decimal" value={texto} onChange={e => setTexto(e.target.value)} disabled={pct === null}
                        className="w-full h-10 pl-3 pr-7 rounded-xl bg-chip text-ink text-body font-black outline-none text-right" />
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-caption font-black text-muted">%</span>
                </span>
                <button type="button" onClick={guardar} disabled={guardando || pct === null || String(pct) === texto}
                    className="h-10 px-4 rounded-xl bg-[#C9341F] text-white text-label font-black disabled:opacity-40">{guardando ? 'Guardando…' : 'Guardar'}</button>
            </div>
        </div>
    );
}

// Ajustes de las cuentas (28-oct-2026): los números con los que se calculan la rentabilidad de cada
// empresa y "Armar día" (base, pasajes, tiempos, jornada). Antes estaban dentro de Rentabilidad.
export default function TabAjustesFinanzas() {
    const [config, setConfig] = useState(null);
    useEffect(() => { api.get('/rentabilidad/config').then(r => setConfig(r.data)).catch(() => setConfig(false)); }, []);
    if (config === false) return <p className="py-10 text-center text-muted">No se pudieron cargar los ajustes.</p>;
    if (!config) return <div className="h-40 rounded-2xl bg-card animate-pulse" />;
    return (
        <div className="space-y-3">
            <PorcentajeImpuestos />
            <p className="text-caption text-muted">Con estos números se calculan los pasajes y los tiempos en la rentabilidad de cada empresa y en "Armar día".</p>
            <TabAjustes config={config} onGuardado={setConfig} />
        </div>
    );
}
